import { type MCPServerInfo } from '../../types';

const SequentialthinkingServer: MCPServerInfo = {
  serverId: 'SEQUENTIALTHINKING',
  name: 'SequentialThinking',
  slug: 'sequentialthinking',
  description:
    'Dynamic and reflective problem-solving through thought sequences.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'COMMUNITY',
    repositoryUrl: 'mcp/sequentialthinking:latest',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'NONE',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  deprecated: true
};

export default SequentialthinkingServer;
